import React, {createContext, useContext} from 'react';

/** The product surface a panel renders in, attached to panel error telemetry. */
export type PanelSurface = 'workspace' | 'report' | 'aria';

const PanelSurfaceContext = createContext<PanelSurface | undefined>(undefined);

/**
 * The outermost provider wins, so a host that embeds another surface's panel
 * grid (ARIA renders the report panel grid) keeps its own label.
 */
export const PanelSurfaceProvider = ({
  surface,
  children,
}: {
  surface: PanelSurface;
  children: React.ReactNode;
}) => {
  const outerSurface = useContext(PanelSurfaceContext);
  return (
    <PanelSurfaceContext.Provider value={outerSurface ?? surface}>
      {children}
    </PanelSurfaceContext.Provider>
  );
};

export const usePanelSurface = () => useContext(PanelSurfaceContext);
